import LinkConfirm from './LinkConfirm';

export default LinkConfirm;
